import { render, staticRenderFns } from "./percursos.vue?vue&type=template&id=4299cf01&scoped=true&"
import script from "./percursos.vue?vue&type=script&lang=js&"
export * from "./percursos.vue?vue&type=script&lang=js&"
import style0 from "./percursos.vue?vue&type=style&index=0&id=4299cf01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4299cf01",
  null
  
)

export default component.exports